var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M4 4.5v24h24m-1.333-4v4m-5.334-6.667V28.5M16 17.833V28.5m-5.333-6.667V28.5M4 15.167c8 0 6.667-6.667 12-6.667s4 6.667 12 6.667","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})
}
var staticRenderFns = []

export { render, staticRenderFns }